import logo from './logo.svg';
import './App.css';
import DNav from './components/navs/regdnav'
import CFNavAndes from './components/navs/cfnavandes'
import CFNavTexture from './components/navs/cfnavtexture'
import HeroSM from './components/heroes/herosmimg'
import HeroLG from './components/heroes/herolgimg'
// import Disqus from './components/disqus'
import Intro from './components/intro'
import Why from './components/why'
import Why2 from './components/why2'
import Summary from './components/summary'
import Summary2 from './components/summary2'
import Mgmt from './components/mgmt'
import Mgmt2 from './components/mgmt2'
import CTA from './components/cta'
import DFoot from './components/footers/dfoot'
import AndesFaq from './components/vendors/andes'
import TextureFaq from './components/vendors/texture'
import AndesFootCF from './components/footers/cffootandes'
import TextureFootCF from './components/footers/cffoottexture'
import Carousel from './components/carousel'
import Terms from './components/terms'
import Terms2 from './components/terms2'
import CTA2 from './components/cta2'
function App() {
  return (
    <div className="App">
      <DNav />
      <HeroLG />
      {/* <Carousel/> */}
      <Intro />
      <Why2 />
      <CTA2/>
      <Summary2 />
      <Terms2 />
      <Mgmt2 />
  
      {/* <TextureFaq/> */}
      <CTA />
<DFoot/>
      {/* <Disqus/> */}
    </div>
  );
}

export default App;
